<p-toast position="bottom-right"></p-toast>
<p-confirmDialog appendTo="body"></p-confirmDialog>
<app-customer-sidebar>
  <app-crud-table body [crudService]="crudService"
                   [transPartKey]="'acceptance-rule'" [fieldId]="'id'" [fieldName]="'accountCode'"
                   [tableConfig]="tableConfig" [newRecord]="newRecord"
                   [(formRecord)]="formRecord" [formConfig]="formConfig"
                   [settingsFormLoadingProgressValue]="settingsFormLoadingProgressValue"
                   [formLoading]="formLoading"
                   (dialogFormVisibleChange)="$event?onFormShow():{}"
                   [writeRoles]="CCRoles.ROLES_CUSTOMER_WRITE" [totalRecords]="totalRecords"
  ></app-crud-table>
</app-customer-sidebar>
